// compareFn
export const ascOrderFn = (a: number, b: number) => a - b;
export const descOrderFn = (a: number, b: number) => b - a;
